// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ServiciosAdicionales.module.css */

.ServiceAditional_serviciosContainer__wGpeI {
  width: 100%;
  background-color: #f0f4f8;
  padding: 64px 40px;
  box-sizing: border-box;
}

.ServiceAditional_sectionLabel__caq0e {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1.8px;
  text-transform: uppercase;
  color: #4cb8a0;
  margin-bottom: 16px;
}

.ServiceAditional_titulo__D61-f {
  font-size: clamp(1.8rem, 4vw, 2.6rem);
  font-weight: 700;
  color: #1a3a5c;
  line-height: 1.2;
  margin-bottom: 12px;
  white-space: nowrap;
}

.ServiceAditional_subtitulo__XwPgJ {
  font-size: 15px;
  color: #667085;
  line-height: 1.6;
  margin-bottom: 40px;
}

.ServiceAditional_serviciosGrid__5VX1K {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 20px;
  width: 100%;
}

.ServiceAditional_servicioCard__3V9NS {
  background: #ffffff;
  border-radius: 12px;
  padding: 22px 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  cursor: pointer;
  transition:
    box-shadow 0.2s,
    transform 0.2s;
  box-sizing: border-box;
}

.ServiceAditional_servicioCard__3V9NS:hover {
  box-shadow: 0 6px 20px rgba(26, 58, 92, 0.12);
  transform: translateY(-2px);
}

.ServiceAditional_cardIcon__gjA9f {
  width: 44px;
  height: 44px;
  background-color: #e6f7f3;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.ServiceAditional_cardIcon__gjA9f svg {
  width: 22px;
  height: 22px;
  color: #2db899;
}

.ServiceAditional_cardName__cNwav {
  font-size: 14px;
  font-weight: 600;
  color: #1a3a5c;
  line-height: 1.3;
}

.ServiceAditional_cardDesc__N2Lg5 {
  font-size: 12px;
  color: #98a2b3;
  line-height: 1.4;
}

@media screen and (max-width: 900px) {
  .ServiceAditional_serviciosGrid__5VX1K {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media screen and (max-width: 500px) {
  .ServiceAditional_serviciosGrid__5VX1K {
    grid-template-columns: 1fr;
  }

  .ServiceAditional_serviciosContainer__wGpeI {
    padding: 40px 20px;
  }
}
/* Contenedor principal */
.ServiceAditional_formContainer__GGiH4 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-size: cover;
  background-position: center;
  padding: 20px;
}

/* Título */
.ServiceAditional_title__MVRkw {
  font-size: 2.5rem;
  margin-bottom: 20px;
  color: #4a5b57;
}

/* Formulario */
.ServiceAditional_form__UUs1D {
  width: 100%;
  max-width: 500px;
  display: flex;
  flex-direction: column;
}

/* Etiquetas */
.ServiceAditional_label__eKIYx {
  font-size: 1rem;
  color: #4a5b57;
  margin-top: 10px;
  margin-bottom: 5px;
}

/* Inputs */
.ServiceAditional_input__Dm7F\\+ {
  padding: 10px;
  font-size: 1rem;
  border: 1px solid #4a5b57;
  border-radius: 5px;
  background-color: rgba(255, 255, 255, 0.8);
  margin-bottom: 10px;
  outline: none;
}

/* Botón */
.ServiceAditional_button__gomhB {
  margin-top: 20px;
  padding: 10px;
  color: #ffff;
  background-color: #4a5b57;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-weight: bold;
  transition: background-color 0.5s ease;
}

.ServiceAditional_button__gomhB:hover {
  background-color: #718983;
}
`, "",{"version":3,"sources":["webpack://./src/styles/Home/ServiceAditional.module.css"],"names":[],"mappings":"AAAA,oCAAoC;;AAEpC;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,yCAAyC;EACzC,eAAe;EACf;;kBAEgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;EACpB;AACF;AACA,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,2BAA2B;EAC3B,aAAa;AACf;;AAEA,WAAW;AACX;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA,cAAc;AACd;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;AACf;;AAEA,UAAU;AACV;EACE,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["/* ServiciosAdicionales.module.css */\n\n.serviciosContainer {\n  width: 100%;\n  background-color: #f0f4f8;\n  padding: 64px 40px;\n  box-sizing: border-box;\n}\n\n.sectionLabel {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 1.8px;\n  text-transform: uppercase;\n  color: #4cb8a0;\n  margin-bottom: 16px;\n}\n\n.titulo {\n  font-size: clamp(1.8rem, 4vw, 2.6rem);\n  font-weight: 700;\n  color: #1a3a5c;\n  line-height: 1.2;\n  margin-bottom: 12px;\n  white-space: nowrap;\n}\n\n.subtitulo {\n  font-size: 15px;\n  color: #667085;\n  line-height: 1.6;\n  margin-bottom: 40px;\n}\n\n.serviciosGrid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 20px;\n  width: 100%;\n}\n\n.servicioCard {\n  background: #ffffff;\n  border-radius: 12px;\n  padding: 22px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);\n  cursor: pointer;\n  transition:\n    box-shadow 0.2s,\n    transform 0.2s;\n  box-sizing: border-box;\n}\n\n.servicioCard:hover {\n  box-shadow: 0 6px 20px rgba(26, 58, 92, 0.12);\n  transform: translateY(-2px);\n}\n\n.cardIcon {\n  width: 44px;\n  height: 44px;\n  background-color: #e6f7f3;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.cardIcon svg {\n  width: 22px;\n  height: 22px;\n  color: #2db899;\n}\n\n.cardName {\n  font-size: 14px;\n  font-weight: 600;\n  color: #1a3a5c;\n  line-height: 1.3;\n}\n\n.cardDesc {\n  font-size: 12px;\n  color: #98a2b3;\n  line-height: 1.4;\n}\n\n@media screen and (max-width: 900px) {\n  .serviciosGrid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media screen and (max-width: 500px) {\n  .serviciosGrid {\n    grid-template-columns: 1fr;\n  }\n\n  .serviciosContainer {\n    padding: 40px 20px;\n  }\n}\n/* Contenedor principal */\n.formContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background-size: cover;\n  background-position: center;\n  padding: 20px;\n}\n\n/* Título */\n.title {\n  font-size: 2.5rem;\n  margin-bottom: 20px;\n  color: #4a5b57;\n}\n\n/* Formulario */\n.form {\n  width: 100%;\n  max-width: 500px;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Etiquetas */\n.label {\n  font-size: 1rem;\n  color: #4a5b57;\n  margin-top: 10px;\n  margin-bottom: 5px;\n}\n\n/* Inputs */\n.input {\n  padding: 10px;\n  font-size: 1rem;\n  border: 1px solid #4a5b57;\n  border-radius: 5px;\n  background-color: rgba(255, 255, 255, 0.8);\n  margin-bottom: 10px;\n  outline: none;\n}\n\n/* Botón */\n.button {\n  margin-top: 20px;\n  padding: 10px;\n  color: #ffff;\n  background-color: #4a5b57;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-weight: bold;\n  transition: background-color 0.5s ease;\n}\n\n.button:hover {\n  background-color: #718983;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"serviciosContainer": `ServiceAditional_serviciosContainer__wGpeI`,
	"sectionLabel": `ServiceAditional_sectionLabel__caq0e`,
	"titulo": `ServiceAditional_titulo__D61-f`,
	"subtitulo": `ServiceAditional_subtitulo__XwPgJ`,
	"serviciosGrid": `ServiceAditional_serviciosGrid__5VX1K`,
	"servicioCard": `ServiceAditional_servicioCard__3V9NS`,
	"cardIcon": `ServiceAditional_cardIcon__gjA9f`,
	"cardName": `ServiceAditional_cardName__cNwav`,
	"cardDesc": `ServiceAditional_cardDesc__N2Lg5`,
	"formContainer": `ServiceAditional_formContainer__GGiH4`,
	"title": `ServiceAditional_title__MVRkw`,
	"form": `ServiceAditional_form__UUs1D`,
	"label": `ServiceAditional_label__eKIYx`,
	"input": `ServiceAditional_input__Dm7F+`,
	"button": `ServiceAditional_button__gomhB`
};
export default ___CSS_LOADER_EXPORT___;
